import Link from 'next/link'
import Icon from '../Icon'
import { cn } from '../../../lib/utils'

export interface MetafieldLabelProps {
  href: string
  label: string
  align?: 'left' | 'right'
}

const MetafieldLabel = ({
  href,
  label,
  align = 'right',
}: MetafieldLabelProps) => {
  return (
    <Link
      href={href}
      className={cn(
        'w-24 flex items-center gap-1 text-gray-300 font-mono hover:text-gray-700',
        { 'justify-end': align == 'right', 'justify-start': align == 'left' },
      )}
    >
      <span
        className={cn('truncate text-right ', {
          'text-right': align == 'right',
          'text-left': align == 'left',
        })}
        style={{ fontSize: 10 }}
      >
        {label}
      </span>
      <Icon name="Database" size={11}></Icon>
    </Link>
  )
}

export default MetafieldLabel
